<template>
  <div class="main">
    <div class="btns">
      <el-select
        v-model="chaVal"
        placeholder="请选择查询方式"
        style="width: 200px; margin: 0 6px"
      >
        <el-option label="用户" value="1"></el-option>
        <el-option label="公司" value="2"></el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请填写用户账号"
        class="input"
      ></el-input>
      <el-row>
        <el-button type="primary" @click="search" style="margin-left: 12px"
          >查询</el-button
        >
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="username" label="帐号"></el-table-column>
      <el-table-column prop="contact_name" label="联系人姓名"></el-table-column>
      <el-table-column
        prop="license_company_name"
        label="公司名称"
      ></el-table-column>
      
      <el-table-column prop="odd_job" label="零工账号">
        <template slot-scope="scope">{{
          scope.row.odd_job ? "是" : "否"
        }}</template>
      </el-table-column>
       <el-table-column prop="is_seed" label="充值客户">
        <template slot-scope="scope">{{
          scope.row.is_seed ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column prop="is_experience" label="体验客户">
        <template slot-scope="scope">{{
          scope.row.is_experience == "1" ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column prop label="公司行业">
        <template slot-scope="scope">{{
          scope.row.industry_name.second_industry_name
        }}</template>
      </el-table-column>

      <el-table-column prop label="公司所在地">
        <template slot-scope="scope">
          {{ scope.row.place_data.city_name }}-{{
            scope.row.place_data.district_name
          }}
        </template>
      </el-table-column>
      <el-table-column prop="agent_name" label="直销、代理商"></el-table-column>
      <el-table-column prop="is_agent" label="是否代理商">
        <template slot-scope="scope">
          {{ scope.row.is_agent ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="is_province_agent" label="是否省代">
        <template slot-scope="scope">
          {{ scope.row.is_province_agent ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="is_province_agent" label="是否关闭">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_expire ? 'success' : 'danger'">
            {{ scope.row.is_expire ? "是" : "否" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="account_access" label="开通权限">
        <template slot-scope="scope">
          {{ scope.row.account_access ? "微信和抖音" : "微信" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="vip_start_time_str"
        label="会员开始时间"
      ></el-table-column>
      <el-table-column
        prop="vip_end_time_str"
        label="会员到期时间"
      ></el-table-column>
      <el-table-column label="职位承诺书">
        <template slot-scope="scope">
          <el-tag :type="scope.row.jd_audit ? 'success' : 'danger'">
            {{ scope.row.jd_audit === 1 ? "有" : "无" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180px"
        v-if="$cookies.get('staff_id') === 'S414292E5F'"
      >
        <template slot-scope="scope">
          <el-button type="warning" @click="bianji(scope.row)">编辑</el-button>
          <el-button type="danger" @click="delete_user(scope.row)"
            >删除账号</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100px" v-else>
        <template slot-scope="scope">
          <el-button type="warning" @click="bianji(scope.row)">编辑</el-button>
          <!-- <el-button type="danger" @click="delete_user(scope.row)">删除账号</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="
        () => {
          dialogVisible = false;
        }
      "
    >
      <el-form :model="form" label-width="125px">
        <el-form-item label="公司名">
          <el-input v-model="form.license_company_name"></el-input>
        </el-form-item>
        <el-form-item label="用户账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="公司地点">
          <el-cascader
            v-model="form.district_id"
            :options="place_data"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="联系人姓名">
          <el-input v-model="form.contact_name"></el-input>
        </el-form-item>
        <el-form-item label="直销、代理商">
          <el-cascader
            placeholder="请选择直销、代理商"
            v-model="agent_id"
            :options="agent_list"
            @change="agent_change"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="是否充值客户">
          <el-select v-model="form.is_seed" placeholder="请选择是否是充值客户">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否体验客户">
          <el-select
            v-model="form.is_experience"
            placeholder="请选择是否是体验客户"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否代理商">
          <el-select
            v-model="form.is_agent"
            @change="is_agentCilck"
            placeholder="请选择是否是体验客户"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否省代">
          <el-select
            v-model="form.is_province_agent"
            @change="is_province_agentCilck"
            placeholder="请选择是否是体验客户"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开通权限">
          <el-select
            v-model="form.account_access"
            @change="account_accessCilck"
            placeholder="请选择开通权限"
          >
            <el-option label="微信和抖音" :value="1"></el-option>
            <el-option label="微信" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员开始时间">
          <el-date-picker
            v-model="form.vip_start_time"
            type="date"
            placeholder="选择会员开始时间"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
            >></el-date-picker
          >
        </el-form-item>
        <el-form-item label="会员到期时间">
          <el-date-picker
            v-model="form.vip_end_time"
            type="date"
            placeholder="选择会员到期时间"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
            >></el-date-picker
          >
        </el-form-item>
        <el-form-item label="是否关闭">
          <el-select
            v-model="form.is_expire"
            placeholder="请选择该账号是否关闭"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司所属行业">
          <el-cascader
            v-model="form.industry_id"
            :props="indus_props"
            :options="industry_data"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="职位承诺书">
          <el-select v-model="form.jd_audit" placeholder="请选择该账号是否含有">
            <el-option label="有" :value="1"></el-option>
            <el-option label="无" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bianjiYes">确 定</el-button>
      </span>
    </el-dialog>
    <!--
    <el-button
      v-if="show"
      type="primary"
      @click="
        is_bianji = true;
        form = {};
      "
      style="margin:20px"
      >编辑</el-button
    >-->
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import axios from "axios";
// import { delete } from 'vue/types/umd';

export default {
  data() {
    return {
      tableData: [],
      show: true,
      input: "",
      is_bianji: false,
      form: {}, //编辑表单数据
      industry_data: [],
      indus_props: {
        value: "industry_id",
        label: "name",
        children: "children",
      },
      place_data: [],

      chaVal: "",
      dialogVisible: false,
      agent_list: [],
      agent_id: [],
      is_agent: "",
      self_agent_id: "",
      contact_phone: "",
      is_province_agent: "",
    };
  },
  created() {
    require("post", "/hr24_user/v1/show_agent_city/", {}).then((res) => {
      if (res.code == 0) {
        console.log(res.data);
        this.agent_list = res.data;
      }
    });
  },
  methods: {
    is_agentCilck(val) {
      if (val) {
        this.form.is_province_agent = 0;
      }
    },
    account_accessCilck() {},
    is_province_agentCilck(val) {
      if (val) {
        this.form.is_agent = 0;
      }
    },

    delete_user(data) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          require("post", "/hr24_user/v1/user_check_backout/", {
            register_id: data.id,
            is_register: 0,
            is_agent: data.is_agent,
            username: data.username,
          }).then((res) => {
            if (!res.code) {
              this.$message.success("删除成功！");
              this.search();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    agent_change(val) {
      console.log(val);
      this.form.agent_id = val[val.length - 1];
    },
    bianji(data) {
      let that = this;
      console.log(data);
      this.self_agent_id = data.self_agent_id;
      this.contact_phone = data.username;
      this.form = data;
      if (data.is_experience == 1) {
        this.form.is_experience = 1;
      } else {
        this.form.is_experience = 0;
      }
      if (data.jd_audit == 1) {
        this.form.jd_audit = 1;
      } else {
        this.form.jd_audit = 0;
      }
      var objString = JSON.stringify(data);
      this.form = JSON.parse(objString);
      this.form.industry_id = [
        this.form.industry_name.first_industry_id,
        this.form.industry_name.second_industry_id,
      ];
      this.form.vip_start_time = this.form.vip_start_time * 1000;
      this.agent_id = data.agent_id;
      this.form.vip_end_time = this.form.vip_end_time * 1000;
      if (that.form.place_data.province_code) {
        that.form.district_id = [
          that.form.place_data.province_code + "",
          that.form.place_data.city_code + "",
          that.form.place_data.district_code + "",
        ];
      } else {
        that.form.district_id = [
          that.form.place_data.city_code + "",
          that.form.place_data.city_code + "",
          that.form.place_data.district_code + "",
        ];
      }
      if (this.form.agent_id.length == 3) {
        this.agent_id = this.form.agent_id;
        this.form.agent_id = this.form.agent_id[this.form.agent_id.length - 1];
      }
      this.is_agent = data.is_agent;
      this.form.is_agent = data.is_agent;
      this.is_province_agent = data.is_province_agent;
      this.form.is_province_agent = data.is_province_agent;
      this.form.is_expire = data.is_expire;
      this.dialogVisible = true;
      console.log(this.form.is_province_agent);
      console.log(this.form);
    },
    bianjiYes() {
      if (!this.form.agent_id) {
        this.$message.warning("请选择直销、代理商");
        return falses;
      }

      // console.log(this.form.length);
      if (this.form.industry_id) {
        this.form.industry_id =
          this.form.industry_id[this.form.industry_id.length - 1];
      }
      if (this.form.district_id) {
        let city_code = this.form.district_id[1]; //市
        let district_code = this.form.district_id[2]; //区
        let province_code = this.form.district_id[0]; //省
        delete this.form.district_id;
        this.form.province_id = Number(province_code);
        this.form.district_id = Number(district_code);
        this.form.city_id = Number(city_code);
      }

      if (this.form.license_company_name && this.chaVal == "2") {
        this.input = this.form.license_company_name;
      }
      if (this.form.username && this.chaVal == "1") {
        this.input = this.form.username;
      }
      if (this.form.vip_end_time) {
        this.form.vip_end_time = this.form.vip_end_time / 1000;
      }
      if (this.form.vip_start_time) {
        this.form.vip_start_time = this.form.vip_start_time / 1000;
      }

      let obj_agent = {};
      if (this.form.is_agent !== this.is_agent) {
        obj_agent.is_agent = this.form.is_agent;
      }
      if (this.form.is_province_agent !== this.is_province_agent) {
        obj_agent.is_province_agent = this.form.is_province_agent;
      }

      if (
        this.form.is_agent !== this.is_agent &&
        this.form.is_province_agent !== this.is_province_agent
      ) {
        if (this.form.is_agent) {
          delete obj_agent.is_province_agent;
        }
        if (this.form.is_province_agent) {
          delete obj_agent.is_agent;
        }
      }

      // this.form.is_agent = 0

      console.log(obj_agent);
      let obj = {
        update_data: {
          self_agent_id: this.self_agent_id,
          username: this.form.username,
          contact_name: this.form.contact_name,
          license_company_name: this.form.license_company_name,
          province_id: this.form.province_id || 0,
          district_id: this.form.district_id || 0,
          city_id: this.form.city_id || 0,
          industry_id: this.form.industry_id,
          vip_end_time: this.form.vip_end_time,
          is_experience: this.form.is_experience,
          is_seed: this.form.is_seed,
          agent_id: this.form.agent_id,
          vip_start_time: this.form.vip_start_time,
          account_access: this.form.account_access,
          jd_audit: this.form.jd_audit,
        },
        lufish_update_agent: {
          is_province_agent: this.is_province_agent,
          is_agent: this.is_agent,
        },
        update_agent: obj_agent,
        user_detail_id: this.form.user_detail_id,
        contact_phone: this.contact_phone,
        is_expire: this.form.is_expire || 0,
      };
      console.log(obj);
      require("post", "/hr24_user/v1/company_update/", obj).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.form = {};
          this.dialogVisible = false;
          this.search();
        } else {
          this.form = {};
          this.$message.warning(res.msg);
        }
      });
    },

    handleClick(row) {
      console.log(row);
      this.allmethods(status);
    },
    errClick(row) {
      console.log(row);
      this.allmethods(status);
    },
    search() {
      if (this.chaVal.length == 0) {
        this.$message.warning("请选择查询方式");
        return false;
      }
      if (this.input.length == 0) {
        this.$message.warning("请填写用户账号或公司");
        return false;
      }
      console.log(111);

      axios.get("/static/json/industry.json").then((res) => {
        console.log(res);
        this.industry_data = res;
      });
      require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.place_data = res.data;
        }
      });
      let search_data = {
        search_data: {},
      };
      if (this.chaVal == 1) {
        search_data.search_data.username = this.input;
      } else {
        search_data.search_data.license_company_name = this.input; // 公司名称
      }
      require("post", "/hr24_user/v1/search_user_info/", search_data).then(
        (res) => {
          if (!res.code) {
            console.log(res);
            this.show = true;
            this.tableData = res.data;
            if (!this.is_bianji) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          } else {
            this.$message.error(res.msg);
            this.tableData = [];
            this.show = false;
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.main {
  min-height: 80vh;
}

.show,
.show_s {
  width: 100%;
}
.show > div {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 33px;
}
.show div > div:first-child {
  color: #303030;
}
.show div > div:last-child {
  color: #606060;
}

.btns {
  display: flex;
  margin-bottom: 20px;
}

.input {
  width: 20%;
}
/* .show_s .el-input {
  width: 40%;
} */
.without {
  font-size: 14px;
  color: #303030;
}
.quYes {
  padding: 12px 0;
  text-align: center;
}
/* .quYes > button {
  float: right;
  margin: 0 5px;
} */
</style>



// WEBPACK FOOTER //
// src/user_management/inquire_resume.vue